<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <p-panel header="{{ 'PRODUCTOESTADO.LBL_ESTADOS' | translate}}">
    <div *ngIf="seccion == 'LISTADO'">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioEstado" name="nomFormularioEstado">
        <div class="grid form-group align-items-center">
          <div class="col-12 md:col-6 lg:col-6">
            <div class="div-form">
              <label>* {{ 'PRODUCTOESTADO.LBL_ESTADO' | translate }}</label>
              <div *ngIf="!f.idProductoEstado.value">
                <p-multiSelect id="idEstados" name="nomEstados" [options]="lisEstados" filter="filter"
                               defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                               selectedItemsLabel="{0} {{ 'LBL_ITEMSELECCIONADO' | translate}}" formControlName="idEstados"
                               emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                               optionValue="value"
                               optionLabel="label"
                ></p-multiSelect>
                <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idEstados.invalid">
                  {{ 'PRODUCTOESTADO.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                </div>
              </div>
              <div *ngIf="f.idProductoEstado.value">
                <label class="falso-combo-texto">{{f.nombreEstado.value}}</label>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <p-checkbox label="{{ 'LBL_HABILITADO' | translate}}" binary="true"
                        id="idIndicadorHabilitado"
                        name="nomIndicadorHabilitado"
                        formControlName="indicadorHabilitado"></p-checkbox>
          </div>
          <div class="col-12 md:col-3 lg:col-3">
            <div *ngIf="!guardando">
              <button class="p-button-datatables" icon="fa fa-plus" label="{{(f.idProductoEstado.value ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
                      type="submit"
                      pButton></button>
            </div>
            <div *ngIf="guardando">
              <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
              <span>{{'LBL_GUARDANDO' | translate }}</span>
            </div>
          </div>
        </div>
      </form>

      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" [loading]="guardando"
                   [value]="lisProductosEstados" selectionMode="single" dataKey="idProductoEstado"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{row.nombreEstado}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editar(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-exchange" data-toggle="tooltip"
                            title="{{'BTN_RELACIONAR' | translate}}" pButton
                            (click)="relacionar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <app-producto-estado-aliado-relacion (dismiss)="cambioSeccion($event)"
                                           [proEstado]="proEstadoSeleccionado" [aliado]="aliado"
                                           *ngIf="seccion==='RELACIONAR'"
                                           [lisTodosEstados]="lisProductosEstados"></app-producto-estado-aliado-relacion>
  </p-panel>
</div>


<p-confirmDialog #cd key="estados">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
